import React, { useState, useEffect } from 'react';
import api from '../api';

// Warns when a client with a similar name already exists, so staff don't create
// a duplicate. Debounced. Used on the Clients form and the New Parcel quick-add.
export default function SimilarClientWarning({ name, excludeId, className = '' }) {
  const [matches, setMatches] = useState([]);
  useEffect(() => {
    const q = (name || '').trim();
    if (q.length < 3) { setMatches([]); return; }
    const t = setTimeout(() => {
      api.get('/clients/similar', { params: { name: q, exclude: excludeId || undefined } })
        .then((r) => setMatches(r.data)).catch(() => {});
    }, 400);
    return () => clearTimeout(t);
  }, [name, excludeId]);

  if (!matches.length) return null;
  return (
    <div className={`bg-amber-50 border border-amber-200 rounded-lg p-2.5 text-xs ${className}`}>
      <p className="font-medium text-amber-800">⚠️ Similar client{matches.length > 1 ? 's' : ''} already exist — don&apos;t create a duplicate:</p>
      <ul className="mt-1 space-y-0.5">
        {matches.map((m) => (
          <li key={m.id}>
            <a href={`/clients/${m.id}`} target="_blank" rel="noreferrer" className="text-amber-700 hover:underline font-medium">{m.name}</a>
            {m.business_name && m.business_name !== m.name ? ` (${m.business_name})` : ''}
            {m.phone ? ` · ${m.phone}` : ''}
          </li>
        ))}
      </ul>
    </div>
  );
}
